export type MoxoConfigPayload = {
  "unique_id": string
  "first_name": string
  "last_name": string,
  "email": string
}

export type MoxoConfig = {
  clientType: MoxoChatTypeEnum;
  domain: string;
  channelId: number;
  containerId: string;
  token?: string
};

export enum MoxoChatTypeEnum {
  ANONYMOUS = 'Anonymous',
  AUTHENTICATED = 'Authenticated',
}

/**
 * Type definition for MEPSDK exported functions.
 *
 * @interface MEPSDKType
 */
export interface MEPSDKType {
  /**
   * Sets up the MEPSDK client.
   *
   * @param {Record<string, string>} data - Configuration data for the MEPSDK client.
   */
  setup: (data: Record<string, string>) => void;

  /**
   * Creates an anonymous live chat session.
   *
   * @param {string} container - The ID of the container in which to open the live chat.
   * @param {string} channel - The channel information for the live chat.
   */
  createAnonymousLiveChat: (
    container: string,
    acdoption: { channelId: number },
  ) => void;

  /**
   * Opens a live chat for a specific client with a given channel ID.
   *
   * @param {string} container - The ID of the container in which to open the live chat.
   * @param {string} channel - The channel information for the live chat.
   * @param {string} [msg] - An optional message to include in the live chat.
   */
  openClientLiveChatWithChannelID: (
    channelId: string,
    containerId: string,
    msg?: string,
  ) => void;

  /**
   * Ends a live chat session.
   *
   * @param {string} id - The ID of the live chat session to end.
   */
  endLiveChat: (id: string) => void;

  /**
   * Minimize the chat.
   */
  hide: () => void;

  /**
   * Maximize the chat.
   */
  show: () => void;

  /**
   * Unlinks the MEPSDK client and clears any existing session.
   */
  unlink: () => void;

  /**
   * Retrieves the list of active live chat sessions.
   *
   * @returns {Promise<any>} A promise that resolves with the list of active live chats.
   */
  getLiveChats: () => Promise<any>;

  /**
   * Shows the MEP window with specific options.
   *
   * @param {string} id - The ID of the MEP window to show.
   * @param {{ binderId: string }} options - Options for showing the MEP window.
   */
  showMEPWindow: (id: string, options: { binderId: string }) => void;

  /**
   * Shows a lightweight version of the MEP window.
   *
   * @param {string} id - The ID of the MEP window to show.
   */
  showMEPWindowLite: (id: string) => void;
}
